import { CustomLink, DateDistanceDisplay, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import React, { useState } from 'react';
import { getProjects, getProjectsExportUrl } from '@/services/projects';
import { BygrProject } from '@/types';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';
import { showModules } from '@/utils/util';
import { createDataTable } from '@/components/DataTable';
import theme from './Projects.module.scss';

const DataTable = createDataTable<BygrProject>();

const ProjectsTable: React.FC<{}> = () => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('name'));
    const [data, , , isLoading] = useAsyncStateWithIsLoading(() => getProjects(tableState), [tableState], null);

    if (!data) {
        return <LoadingIndicator />;
    }
    return (
        <div>
            <h2>Projects</h2>
            <DataTable
                exportUrl={getProjectsExportUrl(tableState)}
                hasSearchField
                isLoading={isLoading}
                data={data.items}
                onStateChange={setTableState}
                state={tableState}
                totalItemCount={data.totalCount}
                className="table style-3">
                <DataTable.Column header="ID" field="id" sortable />
                <DataTable.Column
                    header="Name"
                    field="name"
                    sortable
                    renderer={({ row, value }) => {
                        return (
                            <>
                                <CustomLink to={`/projects/${row.id}`}>{value}</CustomLink>
                                {row.isParentProject && <span className={theme.projectType}>(Parent)</span>}
                                {row.parentProjectId && <span className={theme.projectType}>(Sub)</span>}
                            </>
                        );
                    }}
                />
                <DataTable.Column header="Units" field="numberOfUnits" sortable />
                <DataTable.Column header="Units last 7 days" field="numberOfUnitsLast7Days" sortable />
                <DataTable.Column header="Profile" field="sellerProfile" sortable renderer={({ value }) => value.name} />
                <DataTable.Column
                    header="Modules"
                    field="sellerModules"
                    sortable
                    renderer={({ value }) => showModules(value)}
                />
                <DataTable.Column
                    header="Create date"
                    field="createDate"
                    sortable
                    renderer={(x) => x.value && <DateDistanceDisplay value={x.value} />}
                />
            </DataTable>
        </div>
    );
};

export default ProjectsTable;
